import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  column-gap: 30px;
  row-gap: 30px;
`;

export const NothingToSeeHere = styled.h4`
  text-align: center;
`;
